import Tdg_OrganisationListPagingResultModelBase from '../_generated/modelBases/tdg-organisation-list-paging-result-model-base';

export default class Tdg_OrganisationListPagingResultModel extends Tdg_OrganisationListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
